import { Observable } from 'rxjs';
import {
  Component,
  Input,
  OnInit,
  ChangeDetectionStrategy,
} from '@angular/core';
import { Store, select } from '@ngrx/store';

import {
  detachFeedAlgorithm,
  loadFeedAlgorithms,
} from 'src/app/core/actions/feed.actions';
import {
  selectAttachedFeedAlgorithms,
  selectFeedAlgorithmsLoading,
  selectPendingAlgorithmIds,
} from 'src/app/core/reducers';

import { AppState } from 'src/app/reducers';
import { FeedAlgorithm } from 'src/app/core/models/algorithm.models';
import { PostAlgorithmService } from 'src/app/core/services/post-algorithm.service';

@Component({
  selector: 'app-feed-algorithms',
  templateUrl: './feed-algorithms.component.html',
  styleUrls: ['./feed-algorithms.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class FeedAlgorithmsComponent implements OnInit {
  @Input() objectId!: string;
  @Input() objectClassId!: number;

  attachedAlgorithms$: Observable<FeedAlgorithm[]>;
  loading$: Observable<boolean>;
  pendingAlgorithmIds$: Observable<number[]>;

  constructor(
    private store: Store<AppState>,
    private postAlgorithmService: PostAlgorithmService,
  ) {
    this.attachedAlgorithms$ = this.store.pipe(
      select(selectAttachedFeedAlgorithms),
    );
    this.loading$ = this.store.pipe(select(selectFeedAlgorithmsLoading));
    this.pendingAlgorithmIds$ = this.store.pipe(
      select(selectPendingAlgorithmIds),
    );
  }

  ngOnInit(): void {
    this.store.dispatch(loadFeedAlgorithms({ feedId: this.objectId }));
  }

  isAlgorithmPending(id: number, pending: number[] | null): boolean {
    return !!pending?.includes(id);
  }

  detachAlgorithm(algorithm: FeedAlgorithm): void {
    this.store.dispatch(
      detachFeedAlgorithm({
        feedId: this.objectId,
        algorithmId: algorithm.id,
        scheduleId: algorithm.schedule_id,
      }),
    );
  }

  editAlgorithm(algorithm: FeedAlgorithm): void {
    this.postAlgorithmService.editFeedAlgorithmParams(this.objectId, algorithm);
  }

  hasEditableParams(algorithm: FeedAlgorithm): boolean {
    return !!algorithm.params && !Array.isArray(algorithm.params);
  }
}
